import actionCreatorFactory from 'common/modules/utils/actionCreatorFactory'

const types = {
    SEND_MESSAGE: 'METRICS/SEND_MESSAGE',
    SEND_MESSAGE_SUCCESS: 'METRICS/SEND_MESSAGE_SUCCESS',
    SEND_MESSAGE_ERROR: 'METRICS/SEND_MESSAGE_ERROR',
}

const creators = {
    sendMessage: actionCreatorFactory(types.SEND_MESSAGE),
    sendMessageSuccess: actionCreatorFactory(types.SEND_MESSAGE_SUCCESS),
    sendMessageError: actionCreatorFactory(types.SEND_MESSAGE_ERROR),
}

export {
    types,
    creators,
}
